const AC_TYPES = {
  SET_PERMISSIONS: '[ac] setPermissions',
  CLEAR_PERMISSIONS: '[ac] clearPermissions',
  SET_ROLES: '[ac] setRoles'
}

export default AC_TYPES
